import { render, staticRenderFns } from "./washdetail.vue?vue&type=template&id=5c61441e&"
import script from "./washdetail.vue?vue&type=script&lang=js&"
export * from "./washdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports